import Vue from 'vue'

export default {
  initClient: ({ commit, getters, rootGetters, dispatch }, client) => {
    return new Promise((resolve, reject) => {
      commit('SET_CLIENT', client)
      if (client) {
        if (!getters.clientInfo) {
          Vue.http.post(`${rootGetters.siteUrl}/sponsor/get_client`, { id_client: getters.client, client_language: rootGetters.language })
            .then(response => {
              commit('SET_BUSY', false, { root: true })
              return response.json()
            }, () => {
              commit('SET_BUSY', false, { root: true })
              reject(new Error('Could not get client!'))
            })
            .then(data => {
              commit('SET_CURRENT_CLIENT_INFO', data.client)
              commit('SET_LANGUAGE', data.language, { root: true })
              commit('SET_TRANSLATIONS', data.translations, { root: true })
              commit('SET_CATEGORIES', data.menu.options)
              commit('SET_LANGUAGES', data.menu.languages)
              commit('auth/SET_ROLE', data.role, { root: true })
              commit('SET_SLUG', data.client.slug, { root: true })
              commit('SET_SITE_NAME', data.site_name, { root: true })
              commit('SET_SITE_URL', data.site_url, { root: true })
              commit('ads/SET_ADS_COUNT', data.ads_count, { root: true })
              dispatch('updateUrls', null, { root: true })
              resolve(data.client)
            }, () => {
              commit('SET_BUSY', false, { root: true })
              reject(new Error('Could not get client!'))
            })
        } else {
          resolve(getters.clientInfo)
        }
      } else {
        reject(new Error('No client ID!'))
      }
    })
  },
  resetClientInfo: ({ commit }) => {
    commit('SET_CURRENT_CLIENT_INFO', null)
  },
  setHomeActive: ({ commit }, page) => {
    commit('SET_HOME_ACTIVE', page)
  }
}
